// extracted by mini-css-extract-plugin
export default {"page":"AQ","headerwrap":"BQ","headerblock":"CQ","textwrapper":"EQ","text":"FQ","closerlook":"GQ","arrowwrap":"HQ","icon":"IQ","updown":"JQ","products":"KQ","system":"LQ","systemimage":"MQ","cards":"NQ","note":"OQ","fadein":"PQ"};
    if(module.hot) {
      // 1713809679008
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  